import { RuntimeModel, http } from '@kunlun/dependencies';
import { graphqlQueryFormatter, stringifyToGraphql } from '../../../../utils/serialize';

export const submitData = async (rModel: RuntimeModel, params: any) => {
  const gql = `
        mutation {
          deliAriesTradeLayOutGoodsMutation {
            layOutGoods(
              data: ${stringifyToGraphql(params, ['accountTimeRule'])}
            ) {
              tradeOrderId
            }
          }
        }
      `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesTradeLayOutGoodsMutation.layOutGoods;
};
